import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import { Container } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Prompt } from "react-router-dom";
import { Form, Button, Modal } from "react-bootstrap";

class FuseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  static defaultProps = {
    isShowing: false,
    sizeString: "lg",
    onClose: () => {},
  };

  handleClose = () => {
    if (this.props?.onClose) this.props.onClose();
  };

  renderHeader = () => {
    if (this.props?.title)
      return (
        <Modal.Header closeButton={true}>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
      );
    else return null;
  };

  render() {
    return (
      <Modal
        id={this.props.id}
        show={this.props.isShowing}
        onHide={this.handleClose}
        animation={true}
        size={this.props.sizeString || "lg"}
        scrollable={this.props.scrollable || false}
      >
        {this.renderHeader()}
        <Modal.Body>{this.props.children}</Modal.Body>
      </Modal>
    );
  }
}

FuseModal.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  size: PropTypes.string,
  scrollable: PropTypes.bool
};

export default FuseModal;
